import { NODE_TYPES_PROPERTIES } from '../../../constants/flowGraph';

/**
 * @param {string} currentNodeType
 * @param {string[]} disabledNodeTypes
 * @returns {boolean} True if node is considered deprecated (hidden and disabled), false otherwise
 */
export const isNodeDeprecated = (currentNodeType, disabledNodeTypes) => {
  return disabledNodeTypes?.includes(currentNodeType) && NODE_TYPES_PROPERTIES[currentNodeType].hidden;
};
